// extracted by mini-css-extract-plugin
export default {"premium":"aUl2i53K"};